import { useState, useCallback } from "react";
import MainDetails from "./MainDetails";
import Discount from "./Discount";
import RemoveProduct from "./RemoveProduct";
import { getDiscountsArr } from "@/lib/utils";

const Product = ({ data }) => {
    const discounts = getDiscountsArr(data.pdp_discounts_info);
    const [ removeProductPopup, setRemoveProductPopup ] = useState(false);

    const changeRemoveItemPopup = useCallback((val) => {
        setRemoveProductPopup(val);
    }, []);


    return (
        <div className="border-b border-slate-300 rounded-sm pb-3 mb-4 relative">
            <MainDetails data={data} />
            <div className="flex flex-wrap gap-x-3 gap-y-2 p-2">
                {discounts.map((ele, i) => (
                    <Discount
                        key={ele.label + i}
                        val={ele.val}
                        label={ele.label}
                    />
                ))}
            </div>
            <RemoveProduct 
                data={data} 
                removeProductPopup={removeProductPopup}   
                changeRemoveItemPopup={changeRemoveItemPopup} 
            />
        </div>
    )
}

export default Product